module.exports = __webpack_public_path__ + "static/media/17IT134.6ba4e168.jpg";